import "./hamburger.scss";

export default function HamburgerButton({ state, onClick }: { state: boolean, onClick: () => void }) {
    return (
        <div className={`hamburger${state ? ' open' : ''}`} onClick={ onClick }>
            <div className="top"/>
            <div className="middle"/>
            <div className="bottom"/>
        </div>
    );
};